"use strict";

var _slicedToArray = require("/home/runner/work/technical-documentation/technical-documentation/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/home/runner/work/technical-documentation/technical-documentation/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ajv_1 = require("ajv");

var codegen_1 = require("ajv/dist/compile/codegen");

var code_1 = require("ajv/dist/compile/codegen/code");

var validate_1 = require("ajv/dist/compile/validate");

var errors_1 = require("ajv/dist/compile/errors");

var names_1 = require("ajv/dist/compile/names");

var keyword = "errorMessage";
var used = new ajv_1.Name("emUsed");
var KEYWORD_PROPERTY_PARAMS = {
  required: "missingProperty",
  dependencies: "property",
  dependentRequired: "property"
};
var INTERPOLATION = /\$\{[^}]+\}/;
var INTERPOLATION_REPLACE = /\$\{([^}]+)\}/g;
var EMPTY_STR = /^""\s*\+\s*|\s*\+\s*""$/g;

function errorMessage(options) {
  return {
    keyword: keyword,
    schemaType: ["string", "object"],
    post: true,
    code: function code(cxt) {
      var gen = cxt.gen,
          data = cxt.data,
          schema = cxt.schema,
          schemaValue = cxt.schemaValue,
          it = cxt.it;
      if (it.createErrors === false) return;
      var sch = schema;
      var instancePath = codegen_1.strConcat(names_1.default.instancePath, it.errorPath);
      gen.if(ajv_1._(_templateObject || (_templateObject = _taggedTemplateLiteral(["", " > 0"])), names_1.default.errors), function () {
        if (typeof sch == "object") {
          var _keywordErrorsConfig = keywordErrorsConfig(sch),
              _keywordErrorsConfig2 = _slicedToArray(_keywordErrorsConfig, 2),
              kwdPropErrors = _keywordErrorsConfig2[0],
              kwdErrors = _keywordErrorsConfig2[1];

          if (kwdErrors) processKeywordErrors(kwdErrors);
          if (kwdPropErrors) processKeywordPropErrors(kwdPropErrors);
          processChildErrors(childErrorsConfig(sch));
        }

        var schMessage = typeof sch == "string" ? sch : sch._;
        if (schMessage) processAllErrors(schMessage);
        if (!options.keepErrors) removeUsedErrors();
      });

      function childErrorsConfig(_ref) {
        var properties = _ref.properties,
            items = _ref.items;
        var errors = {};

        if (properties) {
          errors.props = {};

          for (var p in properties) {
            errors.props[p] = [];
          }
        }

        if (items) {
          errors.items = {};

          for (var i = 0; i < items.length; i++) {
            errors.items[i] = [];
          }
        }

        return errors;
      }

      function keywordErrorsConfig(emSchema) {
        var propErrors;
        var errors;

        for (var k in emSchema) {
          if (k === "properties" || k === "items") continue;
          var kwdSch = emSchema[k];

          if (typeof kwdSch == "object") {
            propErrors || (propErrors = {});
            var errMap = propErrors[k] = {};

            for (var p in kwdSch) {
              errMap[p] = [];
            }
          } else {
            errors || (errors = {});
            errors[k] = [];
          }
        }

        return [propErrors, errors];
      }

      function processKeywordErrors(kwdErrors) {
        var kwdErrs = gen.const("emErrors", ajv_1.stringify(kwdErrors));
        var templates = gen.const("templates", getTemplatesCode(kwdErrors, schema));
        gen.forOf("err", names_1.default.vErrors, function (err) {
          return gen.if(matchKeywordError(err, kwdErrs), function () {
            return gen.code(ajv_1._(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", "[", ".keyword].push(", ")"])), kwdErrs, err, err)).assign(ajv_1._(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ".", ""])), err, used), true);
          });
        });
        var singleError = options.singleError;

        if (singleError) {
          var message = gen.let("message", ajv_1._(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\"\""]))));
          var paramsErrors = gen.let("paramsErrors", ajv_1._(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["[]"]))));
          loopErrors(function (key) {
            gen.if(message, function () {
              return gen.code(ajv_1._(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", " += ", ""])), message, typeof singleError == "string" ? singleError : ";"));
            });
            gen.code(ajv_1._(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", " += ", ""])), message, errMessage(key)));
            gen.assign(paramsErrors, ajv_1._(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["", ".concat(", "[", "])"])), paramsErrors, kwdErrs, key));
          });
          errors_1.reportError(cxt, {
            message: message,
            params: ajv_1._(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["{errors: ", "}"])), paramsErrors)
          });
        } else {
          loopErrors(function (key) {
            return errors_1.reportError(cxt, {
              message: errMessage(key),
              params: ajv_1._(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["{errors: ", "[", "]}"])), kwdErrs, key)
            });
          });
        }

        function loopErrors(body) {
          gen.forIn("key", kwdErrs, function (key) {
            return gen.if(ajv_1._(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["", "[", "].length"])), kwdErrs, key), function () {
              return body(key);
            });
          });
        }

        function errMessage(key) {
          return ajv_1._(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["", " in ", " ? ", "[", "]() : ", "[", "]"])), key, templates, templates, key, schemaValue, key);
        }
      }

      function processKeywordPropErrors(kwdPropErrors) {
        var kwdErrs = gen.const("emErrors", ajv_1.stringify(kwdPropErrors));
        var templatesCode = [];

        for (var k in kwdPropErrors) {
          templatesCode.push([k, getTemplatesCode(kwdPropErrors[k], schema[k])]);
        }

        var templates = gen.const("templates", gen.object.apply(gen, templatesCode));
        var kwdPropParams = gen.scopeValue("obj", {
          ref: KEYWORD_PROPERTY_PARAMS,
          code: ajv_1.stringify(KEYWORD_PROPERTY_PARAMS)
        });
        var propParam = gen.let("emPropParams");
        var paramsErrors = gen.let("emParamsErrors");
        gen.forOf("err", names_1.default.vErrors, function (err) {
          return gen.if(matchKeywordError(err, kwdErrs), function () {
            gen.assign(propParam, ajv_1._(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["", "[", ".keyword]"])), kwdPropParams, err));
            gen.assign(paramsErrors, ajv_1._(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["", "[", ".keyword][", ".params[", "]]"])), kwdErrs, err, err, propParam));
            gen.if(paramsErrors, function () {
              return gen.code(ajv_1._(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["", ".push(", ")"])), paramsErrors, err)).assign(ajv_1._(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["", ".", ""])), err, used), true);
            });
          });
        });
        gen.forIn("key", kwdErrs, function (key) {
          return gen.forIn("keyProp", ajv_1._(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["", "[", "]"])), kwdErrs, key), function (keyProp) {
            gen.assign(paramsErrors, ajv_1._(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["", "[", "][", "]"])), kwdErrs, key, keyProp));
            gen.if(ajv_1._(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["", ".length"])), paramsErrors), function () {
              var tmpl = gen.const("tmpl", ajv_1._(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["", "[", "] && ", "[", "][", "]"])), templates, key, templates, key, keyProp));
              errors_1.reportError(cxt, {
                message: ajv_1._(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["", " ? ", "() : ", "[", "][", "]"])), tmpl, tmpl, schemaValue, key, keyProp),
                params: ajv_1._(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["{errors: ", "}"])), paramsErrors)
              });
            });
          });
        });
      }

      function processChildErrors(childErrors) {
        var props = childErrors.props,
            items = childErrors.items;
        if (!props && !items) return;

        var isObj = ajv_1._(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["typeof ", " == \"object\""])), data);

        var isArr = ajv_1._(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["Array.isArray(", ")"])), data);

        var childErrs = gen.let("emErrors");
        var childKwd;
        var childProp;
        var templates = gen.let("templates");

        if (props && items) {
          childKwd = gen.let("emChildKwd");
          gen.if(isObj);
          gen.if(isArr, function () {
            init(items, schema.items);
            gen.assign(childKwd, ajv_1.str(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["items"]))));
          }, function () {
            init(props, schema.properties);
            gen.assign(childKwd, ajv_1.str(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["properties"]))));
          });
          childProp = ajv_1._(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["[", "]"])), childKwd);
        } else if (items) {
          gen.if(isArr);
          init(items, schema.items);
          childProp = ajv_1._(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral([".items"])));
        } else if (props) {
          gen.if(codegen_1.and(isObj, codegen_1.not(isArr)));
          init(props, schema.properties);
          childProp = ajv_1._(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral([".properties"])));
        }

        gen.forOf("err", names_1.default.vErrors, function (err) {
          return ifMatchesChildError(err, childErrs, function (child) {
            return gen.code(ajv_1._(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["", "[", "].push(", ")"])), childErrs, child, err)).assign(ajv_1._(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["", ".", ""])), err, used), true);
          });
        });
        gen.forIn("key", childErrs, function (key) {
          return gen.if(ajv_1._(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["", "[", "].length"])), childErrs, key), function () {
            errors_1.reportError(cxt, {
              message: ajv_1._(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["", " in ", " ? ", "[", "]() : ", "", "[", "]"])), key, templates, templates, key, schemaValue, childProp, key),
              params: ajv_1._(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["{errors: ", "[", "]}"])), childErrs, key)
            });
            gen.assign(ajv_1._(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["", "[", "-1].instancePath"])), names_1.default.vErrors, names_1.default.errors), ajv_1._(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["", " + \"/\" + ", ".replace(/~/g, \"~0\").replace(/\\//g, \"~1\")"], ["", " + \"/\" + ", ".replace(/~/g, \"~0\").replace(/\\\\//g, \"~1\")"])), instancePath, key));
          });
        });
        gen.endIf();

        function init(children, msgs) {
          gen.assign(childErrs, ajv_1.stringify(children));
          gen.assign(templates, getTemplatesCode(children, msgs));
        }
      }

      function processAllErrors(schMessage) {
        var errs = gen.const("emErrs", ajv_1._(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["[]"]))));
        gen.forOf("err", names_1.default.vErrors, function (err) {
          return gen.if(matchAnyError(err), function () {
            return gen.code(ajv_1._(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["", ".push(", ")"])), errs, err)).assign(ajv_1._(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["", ".", ""])), err, used), true);
          });
        });
        gen.if(ajv_1._(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["", ".length"])), errs), function () {
          return errors_1.reportError(cxt, {
            message: templateExpr(schMessage),
            params: ajv_1._(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["{errors: ", "}"])), errs)
          });
        });
      }

      function removeUsedErrors() {
        var errs = gen.const("emErrs", ajv_1._(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["[]"]))));
        gen.forOf("err", names_1.default.vErrors, function (err) {
          return gen.if(ajv_1._(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["!", ".", ""])), err, used), function () {
            return gen.code(ajv_1._(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["", ".push(", ")"])), errs, err));
          });
        });
        gen.assign(names_1.default.vErrors, errs).assign(names_1.default.errors, ajv_1._(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["", ".length"])), errs));
      }

      function matchKeywordError(err, kwdErrs) {
        return codegen_1.and(ajv_1._(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["", ".keyword !== ", ""])), err, keyword), ajv_1._(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["!", ".", ""])), err, used), ajv_1._(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["", ".instancePath === ", ""])), err, instancePath), ajv_1._(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["", ".keyword in ", ""])), err, kwdErrs), // TODO match the end of the string?
        ajv_1._(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["", ".schemaPath.indexOf(", ") === 0"])), err, it.errSchemaPath), ajv_1._(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["/^\\/[^\\/]*$/.test(", ".schemaPath.slice(", "))"], ["/^\\\\/[^\\\\/]*$/.test(", ".schemaPath.slice(", "))"])), err, it.errSchemaPath.length));
      }

      function ifMatchesChildError(err, childErrs, thenBody) {
        gen.if(codegen_1.and(ajv_1._(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["", ".keyword !== ", ""])), err, keyword), ajv_1._(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["!", ".", ""])), err, used), ajv_1._(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["", ".instancePath.indexOf(", ") === 0"])), err, instancePath)), function () {
          var childRegex = gen.scopeValue("pattern", {
            ref: /^\/([^/]*)(?:\/|$)/,
            code: ajv_1._(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["new RegExp(\"^\\/([^/]*)(?:\\/|$)\")"], ["new RegExp(\"^\\\\\\/([^/]*)(?:\\\\\\/|$)\")"])))
          });
          var matches = gen.const("emMatches", ajv_1._(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["", ".exec(", ".instancePath.slice(", ".length))"])), childRegex, err, instancePath));
          var child = gen.const("emChild", ajv_1._(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["", " && ", "[1].replace(/~1/g, \"/\").replace(/~0/g, \"~\")"])), matches, matches));
          gen.if(ajv_1._(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["", " !== undefined && ", " in ", ""])), child, child, childErrs), function () {
            return thenBody(child);
          });
        });
      }

      function matchAnyError(err) {
        return codegen_1.and(ajv_1._(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["", ".keyword !== ", ""])), err, keyword), ajv_1._(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["!", ".", ""])), err, used), codegen_1.or(ajv_1._(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["", ".instancePath === ", ""])), err, instancePath), codegen_1.and(ajv_1._(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["", ".instancePath.indexOf(", ") === 0"])), err, instancePath), ajv_1._(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["", ".instancePath[", ".length] === \"/\""])), err, instancePath))), ajv_1._(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["", ".schemaPath.indexOf(", ") === 0"])), err, it.errSchemaPath), ajv_1._(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["", ".schemaPath[", ".length] === \"/\""])), err, it.errSchemaPath));
      }

      function getTemplatesCode(keys, msgs) {
        var templatesCode = [];

        for (var k in keys) {
          var msg = msgs[k];
          if (INTERPOLATION.test(msg)) templatesCode.push([k, templateFunc(msg)]);
        }

        return gen.object.apply(gen, templatesCode);
      }

      function templateExpr(msg) {
        if (!INTERPOLATION.test(msg)) return ajv_1.stringify(msg);
        return new code_1._Code(code_1.safeStringify(msg).replace(INTERPOLATION_REPLACE, function (_s, ptr) {
          return "\" + JSON.stringify(".concat(validate_1.getData(ptr, it), ") + \"");
        }).replace(EMPTY_STR, ""));
      }

      function templateFunc(msg) {
        return ajv_1._(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["function(){return ", "}"])), templateExpr(msg));
      }
    },
    metaSchema: {
      anyOf: [{
        type: "string"
      }, {
        type: "object",
        properties: {
          properties: {
            $ref: "#/$defs/stringMap"
          },
          items: {
            $ref: "#/$defs/stringList"
          },
          required: {
            $ref: "#/$defs/stringOrMap"
          },
          dependencies: {
            $ref: "#/$defs/stringOrMap"
          }
        },
        additionalProperties: {
          type: "string"
        }
      }],
      $defs: {
        stringMap: {
          type: "object",
          additionalProperties: {
            type: "string"
          }
        },
        stringOrMap: {
          anyOf: [{
            type: "string"
          }, {
            $ref: "#/$defs/stringMap"
          }]
        },
        stringList: {
          type: "array",
          items: {
            type: "string"
          }
        }
      }
    }
  };
}

var ajvErrors = function ajvErrors(ajv) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!ajv.opts.allErrors) throw new Error("ajv-errors: Ajv option allErrors must be true");

  if (ajv.opts.jsPropertySyntax) {
    throw new Error("ajv-errors: ajv option jsPropertySyntax is not supported");
  }

  return ajv.addKeyword(errorMessage(options));
};

exports.default = ajvErrors;
module.exports = ajvErrors;
module.exports.default = ajvErrors;